import {
    BarChart,
    Bar,
    XAxis,
    YAxis,
    Tooltip,
    ResponsiveContainer,
    Cell,
    CartesianGrid,

} from "recharts";
import { Card, Col, Row, CardHeader, CardBody, CardFooter } from "reactstrap";

const BarChart2 = () => {

    const data = [
        {

            name: 'jan',
            
            KWH: 45,
        },
        {

            name: 'feb',
           
            KWH: 63,
        },
        {

            name: 'mar',
            KWH: 45,
        },
        {

            name: 'apr',
           
            KWH: 55,
        },
        {

            name: 'may',
            
            KWH: 50,
        },
        {

            name: 'june',
           
            KWH: 55,
        },
        {

            name: 'july',
           
            KWH: 50,
        }
    ]

    return (

        <Col style={{ height: '100%' }}>


            <Card className="m-0 b-r-0">


                <CardHeader>
                    <h5 style={{ fontWeight: '600' }}>Power Consumption</h5>
                </CardHeader>

                <CardBody>
                    <ResponsiveContainer width="100%" height={300} >
                        <BarChart
                            data={data}
                            barCategoryGap='0%'
                            barGap='1'

                        >

                            <XAxis dataKey="name" padding={{ left: 5, right: 5 }} />
                            <YAxis 
                              domain={[0, 100]} />



                            <Tooltip formatter={(KWH: number, name: string) => [`${KWH}`, name]}
                                cursor={false}
                                contentStyle={{
                                    backgroundColor: "white", // Tooltip box color
                                    borderRadius: "4px",
                                    border: "1px solid #ddd",
                                    boxShadow: "0 4px 6px rgba(0,0,0,0.1)",
                                }}

                            />
                            
                            <Bar
                                dataKey="KWH"
                                animationDuration={600}
                                label={{ position: "top" }}
                                radius={[0, 0, 0, 0]}
                                barSize={30}
                                fill="#2B5F60"

                            >

                                {data.map((entry: any, index) => (
                                    <Cell key={`cell-${index}`} />
                                ))}

                            </Bar>


                        </BarChart>
                    </ResponsiveContainer>
                </CardBody>
                

            </Card>

        </Col>

    )
}

export default BarChart2